import { render, staticRenderFns } from "./importdata.vue?vue&type=template&id=8022be64&scoped=true&"
import script from "./importdata.vue?vue&type=script&lang=js&"
export * from "./importdata.vue?vue&type=script&lang=js&"
import style0 from "./importdata.vue?vue&type=style&index=0&id=8022be64&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8022be64",
  null
  
)

export default component.exports